import { render } from "./Datenschutz.vue?vue&type=template&id=7236b4f1"
const script = {}

import "./Datenschutz.vue?vue&type=style&index=0&id=7236b4f1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__